import { storageGet } from '@/services/storage'
function guest(to, from, next) {
	const user = storageGet('@stup:user')
	if (user) {
		next('dashboard')
	}
	return next()
}

export default guest
